(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamDeleteController',CareTeamDeleteController);

    CareTeamDeleteController.$inject = ['$uibModalInstance', 'entity', 'CareTeam'];

    function CareTeamDeleteController($uibModalInstance, entity, CareTeam) {
        var vm = this;

        vm.careTeam = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CareTeam.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
